
import { Box, Typography } from "@mui/material"
import { get } from "lodash";
import { FieldProps, useRecordContext } from "react-admin"
import AppleIcon from '@mui/icons-material/Apple';
import AndroidIcon from '@mui/icons-material/Android';  
import WebIcon from '@mui/icons-material/Web';
interface Client {
    type?: string; //web-desktop | web-mobile | pwa | ios | android
    version?: string;
    updateId?: string;
}

const ClientIcon = (type?: string) => {
    if (!type) return null;
    switch (type) {
        case "ios": return <AppleIcon />
        case "android": return <AndroidIcon />
        case "web-desktop": return <WebIcon />
        case "web-mobile": return <WebIcon />
        case "pwa": return <WebIcon />
    }
}

export const ClientField = (props: FieldProps) => {
    const record = useRecordContext(props)
    const source = props.source;
    const value: Client = get(record, source);
    console.log(value);
    return value ? (
        <Box display="flex" flexDirection="column" alignItems="center" sx={{ "& svg": { color: "text.secondary" } }}>
            {ClientIcon(value.type)}
            <Typography variant="caption">{value.version}</Typography>
        </Box>
    ) : null
}